export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["debtTermIdAndHolderIdDoesNotExist"] = "debtTermIdAndHolderIdDoesNotExist";
    ErrorCode["debtTermIdDoesNotExist"] = "debtTermIdDoesNotExist";
    ErrorCode["discountCanNotBeNegativeNumber"] = "discountCanNotBeNegativeNumber";
    ErrorCode["discountMustBeGreaterThanZero"] = "discountMustBeGreaterThanZero";
    ErrorCode["emailAddressMustBeUnique"] = "emailAddressMustBeUnique";
    ErrorCode["emailAddressNotProvidedByOAuthProvider"] = "emailAddressNotProvidedByOAuthProvider";
    ErrorCode["eventNameMustBeUnique"] = "eventNameMustBeUnique";
    ErrorCode["firstNameMustBeTrimmed"] = "firstNameMustBeTrimmed";
    ErrorCode["holderIdDoesNotExist"] = "holderIdDoesNotExist";
    ErrorCode["issuingOrganizationCanNotBeHolder"] = "issuingOrganizationCanNotBeHolder";
    ErrorCode["lastNameMustBeTrimmed"] = "lastNameMustBeTrimmed";
    ErrorCode["llcCanNotBeFormedInCa"] = "llcCanNotBeFormedInCa";
    ErrorCode["ltdCanNotBeFormedInUs"] = "ltdCanNotBeFormedInUs";
    ErrorCode["networkError"] = "networkError";
    ErrorCode["optionPlanIdAndHolderIdDoesNotExist"] = "optionPlanIdAndHolderIdDoesNotExist";
    ErrorCode["optionPlanIdDoesNotExist"] = "optionPlanIdDoesNotExist";
    ErrorCode["optionPlanNameMustBeTrimmed"] = "optionPlanNameMustBeTrimmed";
    ErrorCode["optionPlanNameMustBeUnique"] = "optionPlanNameMustBeUnique";
    ErrorCode["organizationIdDoesNotExist"] = "organizationIdDoesNotExist";
    ErrorCode["organizationNameMustBeTrimmed"] = "organizationNameMustBeTrimmed";
    ErrorCode["organizationNameMustBeUnique"] = "organizationNameMustBeUnique";
    ErrorCode["safeTermIdAndHolderIdDoesNotExist"] = "safeTermIdAndHolderIdDoesNotExist";
    ErrorCode["safeTermIdDoesNotExist"] = "safeTermIdDoesNotExist";
    ErrorCode["safeTermNameMustBeTrimmed"] = "safeTermNameMustBeTrimmed";
    ErrorCode["safeTermNameMustBeUnique"] = "safeTermNameMustBeUnique";
    ErrorCode["shareClassIdAndHolderIdDoesNotExist"] = "shareClassIdAndHolderIdDoesNotExist";
    ErrorCode["shareClassIdDoesNotExist"] = "shareClassIdDoesNotExist";
    ErrorCode["shareClassNameMustBeUnique"] = "shareClassNameMustBeUnique";
    ErrorCode["unauthorized"] = "unauthorized";
    ErrorCode["unknownError"] = "unknownError";
    ErrorCode["unknownMemberIds"] = "unknownMemberIds";
    ErrorCode["invalid email"] = "invalid email";
    ErrorCode["invalid eventId"] = "invalid eventId";
    ErrorCode["email exists"] = "email exists";
    ErrorCode["at least one verified email is required"] = "at least one verified email is required";
    ErrorCode["verificationEmailSent"] = "verificationEmailSent";
    ErrorCode["token expired"] = "token expired";
    ErrorCode["emailVerified"] = "emailVerified";
    ErrorCode["invalid name"] = "invalid name";
    ErrorCode["invalid quantity"] = "invalid quantity";
    ErrorCode["invalid planSize"] = "invalid planSize";
    ErrorCode["invalid principal"] = "invalid principal";
})(ErrorCode || (ErrorCode = {}));
export var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["debtTermIdAndHolderIdDoesNotExist"] = "debtTermIdAndHolderIdDoesNotExist";
    ErrorMessage["debtTermIdDoesNotExist"] = "debtTermIdDoesNotExist";
    ErrorMessage["discountCanNotBeNegativeNumber"] = "Discount can not be negative number";
    ErrorMessage["discountMustBeGreaterThanZero"] = "Discount must be greater than zero";
    ErrorMessage["emailAddressMustBeUnique"] = "Email address must be unique";
    ErrorMessage["emailAddressNotProvidedByOAuthProvider"] = "emailAddressNotProvidedByOAuthProvider";
    ErrorMessage["eventNameMustBeUnique"] = "Event name must be unique";
    ErrorMessage["firstNameMustBeTrimmed"] = "First name must be trimmed";
    ErrorMessage["holderIdDoesNotExist"] = "holderIdDoesNotExist";
    ErrorMessage["issuingOrganizationCanNotBeHolder"] = "issuingOrganizationCanNotBeHolder";
    ErrorMessage["lastNameMustBeTrimmed"] = "Last name must be trimmed";
    ErrorMessage["llcCanNotBeFormedInCa"] = "llc can not be formed in Canada";
    ErrorMessage["ltdCanNotBeFormedInUs"] = "ltd can not be formed in Us";
    ErrorMessage["networkError"] = "Network error";
    ErrorMessage["optionPlanIdAndHolderIdDoesNotExist"] = "optionPlanIdAndHolderIdDoesNotExist";
    ErrorMessage["optionPlanIdDoesNotExist"] = "optionPlanIdDoesNotExist";
    ErrorMessage["optionPlanNameMustBeTrimmed"] = "Option plan name must be trimmed";
    ErrorMessage["optionPlanNameMustBeUnique"] = "Option plan name must be unique";
    ErrorMessage["organizationIdDoesNotExist"] = "organizationIdDoesNotExist";
    ErrorMessage["organizationNameMustBeTrimmed"] = "Organization name must be trimmed";
    ErrorMessage["organizationNameMustBeUnique"] = "Legal name must be unique";
    ErrorMessage["safeTermIdAndHolderIdDoesNotExist"] = "safeTermIdAndHolderIdDoesNotExist";
    ErrorMessage["safeTermIdDoesNotExist"] = "SAFE term Id does not exist";
    ErrorMessage["safeTermNameMustBeTrimmed"] = "SAFE term name must be trimmed";
    ErrorMessage["safeTermNameMustBeUnique"] = "SAFE term name must be unique";
    ErrorMessage["shareClassIdAndHolderIdDoesNotExist"] = "shareClassIdAndHolderIdDoesNotExist";
    ErrorMessage["shareClassIdDoesNotExist"] = "shareClassIdDoesNotExist";
    ErrorMessage["shareClassNameMustBeUnique"] = "Name must be unique";
    ErrorMessage["unauthorized"] = "Unauthorized";
    ErrorMessage["unknownError"] = "Unknown error";
    ErrorMessage["unknownMemberIds"] = "Unknown member Ids";
    ErrorMessage["invalid email"] = "Invalid email";
    ErrorMessage["invalid eventId"] = "invalid eventId";
    ErrorMessage["email exists"] = "Duplicate email";
    ErrorMessage["at least one verified email is required"] = "A confirmed email address is required";
    ErrorMessage["verificationEmailSent"] = "Verification email sent, check your inbox";
    ErrorMessage["token expired"] = "Token expired";
    ErrorMessage["emailVerified"] = "Email verified, thanks!";
    ErrorMessage["invalid name"] = "Invalid name (Note: name must be unique)";
    ErrorMessage["invalid quantity"] = "The quantity is invalid. There are not enough authorized shares available.";
    ErrorMessage["invalid planSize"] = "The plan size is invalid. There are not enough authorized shares available.";
    ErrorMessage["invalid principal"] = "The principal is invalid. Principal is restricted by the total principal value in the connected debt term.";
})(ErrorMessage || (ErrorMessage = {}));
//# sourceMappingURL=errors.js.map